var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cly-in-page-notification color-cool-gray-100 bg-red-10 text-medium bu-p-2 center"},[_vm._t("default",function(){return [_c('span',[_vm._v(" "+_vm._s(_vm.innerText)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }